import { render, staticRenderFns } from "./RoomInfoCardSkeleton.vue?vue&type=template&id=70aef0da&scoped=true"
import script from "./RoomInfoCardSkeleton.vue?vue&type=script&lang=js"
export * from "./RoomInfoCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./RoomInfoCardSkeleton.vue?vue&type=style&index=0&id=70aef0da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aef0da",
  null
  
)

export default component.exports